
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { KanbanState } from '../kanban.model';
import { Board, Card, Ticket } from '../../backend/backendapi';
import { WindowType } from '../../../util';
import KanbanCard from '../board/KanbanCard';

declare var window: WindowType;

@Component({
  components: {
    KanbanCard,
  },
})
export default class AssignedCardsModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  get cards(): { board: Board, flow: Ticket, card: Card }[] {
    return this.state.boards
        .flatMap(b => b.tickets?.map(t => ({ board: b, flow: t })) ?? [])
        .flatMap(f => f.flow.cards?.map(c => ({ ...f, card: c })) ?? [])
        .filter(e => e.card.responsibles?.some(r => r.userId === window.application.user.id));
  }
  
  get modalSize(): string {
    return this.state.settings?.layout === 'trello' ? 'modal-xs' : 'modal-xl';
  }

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
